export default "__VITE_ASSET__BKVlqIbu__"